// Avatar — initials chip used wherever a user owns or watches an item.
// Microsoft Graph profile photo integration is omitted from the BSP
// port; the chip falls back to initials in the BSP blue tint.
import type { PlannerOwner } from "../../../../../../shared/team-planner/schemas";
import { initials } from "../utils";

export function Avatar({
  owner,
  size = 22,
  title,
}: {
  owner: Pick<PlannerOwner, "displayName" | "email"> | null;
  size?: number;
  title?: string;
}) {
  const name = owner?.displayName ?? owner?.email ?? "";
  return (
    <span
      className="tp-avatar"
      title={title ?? name}
      style={{ width: size, height: size, fontSize: Math.round(size / 2.4) }}
    >
      {initials(name) || "··"}
    </span>
  );
}

export function AvatarStack({
  owners,
  total,
  max = 3,
}: {
  owners: Array<Pick<PlannerOwner, "displayName" | "email">>;
  total?: number;
  max?: number;
}) {
  const overflow = (total ?? owners.length) - max;
  return (
    <span style={{ display: "inline-flex", gap: -6, alignItems: "center" }}>
      {owners.slice(0, max).map((o, i) => (
        <span key={i} style={{ marginLeft: i === 0 ? 0 : -6 }}>
          <Avatar owner={o} />
        </span>
      ))}
      {overflow > 0 ? (
        <span
          className="tp-avatar"
          style={{ marginLeft: -6, background: "var(--ink-200)", color: "var(--ink-700)" }}
          title={`+${overflow} more`}
        >
          +{overflow}
        </span>
      ) : null}
    </span>
  );
}
